import {Component} from '@angular/core';
import * as ng from '@angular/core';
import * as Rx from 'rxjs'
import {Mag2ApiClient} from "../../../lib/api-client/mag2-api-client";
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "../../../env/environment";
import {catchError, mergeMap} from "rxjs/operators";

@Component({
  templateUrl: './live-terms-page.component.html',
  styleUrls: ['./live-terms-page.component.scss']
})
export class LiveTermsPageComponent implements ng.OnInit {

  @ng.ViewChild("iframe", {static: true})
  iframe: ng.ElementRef<HTMLIFrameElement>;

  error = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute
    ) {
  }

  ngOnInit(): void {
    const fixed = 250;
    if (fixed <= window.innerHeight) {
      this.iframe.nativeElement.height = (window.innerHeight - fixed) * 0.8 + 'px';
    }
  }

  agree(): void {
    this.error = false;
    let to = decodeURIComponent(this.route.snapshot.queryParamMap.get("to"));
    console.log('to', to)

    // クエリパラメータがあるか
    let queryObj = null
    const isQuery = (new RegExp('\\?')).test(to);
    console.log('isQuery', isQuery)

    if(isQuery) {
       // クエリパラメータ文字列をオブジェクトに変換
      const pathArray = to.replace(/^\//, "").split('?')
      to = pathArray[0]
      queryObj = pathArray[1].substring(1).split('&').map((p) => p.split('='))
      .reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {});
    }
    const redirection = Rx.from((to === null)
      ? this.router.navigateByUrl(environment.baseURL.mag2www)
      : this.router.navigate([to], {queryParams: queryObj})
    );

    Mag2ApiClient.putTermsAgreementStatus({agreed: true}).pipe(
      mergeMap(() => redirection),
      catchError(e => {
        console.error(e);
        this.error = true;
        return Rx.of();
      })
    ).subscribe()
  }
}
